import http from '~/common/http'
export default {
    // 销售提成业绩
    getList(params, action) {
        return http.get('/api/sale-analysis/' + action, {
            params: params
        });
    },
}


// WEBPACK FOOTER //
// ./src/services/saleanalysisCount.js